"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsPerformanceBand = void 0;
/**
 * Settings Performance Band
 * @property {string}     code            - performance band code, i.e not-proficient
 * @property {number}     min             - lower band limit
 * @property {number}     max             - higher band limit
 *
 * @author jennifer.ajoy
 */
var SettingsPerformanceBand = /** @class */ (function () {
    function SettingsPerformanceBand(band) {
        if (band === void 0) { band = {}; }
        Object.assign(this, band);
    }
    return SettingsPerformanceBand;
}());
exports.SettingsPerformanceBand = SettingsPerformanceBand;
